module.exports = __webpack_public_path__ + "static/media/icon_not_equal_to.2400e1bf.svg";